import Vue from 'vue';
import Vuex from 'vuex';
import jwt_decode from 'jwt-decode';
import plans from './modules/plans';
import project from './modules/project';
import conceptValuation from './modules/conceptValuation';
import generationHistory from './modules/generationHistory';
import aiGroupInterview from './modules/aiGroupInterview';
import role from '@/shared/constants/role';
import moment from 'moment';
import constants from '@/shared/constants/constants.js'
import { convertCountryToTargetCountry, isTimeExpired } from '../shared/functions';
import axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    projectId: 0,
    projectName: '',
    projectNameAutoCreate: '',
    isSelectImageWord: false,
    nImage: 0,
    authUser: {},
    isAuthenticated: false,
    jwt: localStorage.getItem('token'),
    endpoints: {
      obtainJWT: 'http://localhost:8000/auth/obtain_token/',
      refreshJWT: `${process.env.API_BASE}/auth/refresh_token/`,
      baseUrl: 'http://localhost:8000/'
    },
    //modal project-create/confirm
    modalSurveyConfirm: false,
    //modal auto-create/confirm
    modalProcess2: false,
    lastRoute: null,
    paramsLastRoute: {},
    paramsLastStep: {},
    currentImageUpload: [],
    pathCurrentImageUpload: [],
    pathCurrentOriginImageUpload: [],
    currentImageUsed: 0,
    isResultPage: false,
    menuChecked: null,
    segmentChecked: [],
    selectedPlan: '',
    selectedPlanGenerate: '',
    currentMenu: 0,
    blur: constants.BLUR_LIST[0].id,
    categoryAutoCreate: 1,
    drinkFlag: null,
    imageShow: null,
    countComputation: 10,
    countStyle: 0,
    oldProject: 0,
    oldProjectRegisted: 0,
    oldProjectShelve: 0,
    segmentHeatMap: false,
    segmentConceptMatching: false,
    iter: 10,
    isReportAll: false,
    tabResultReportAll: false,
    projectReportAll: null,
    standardValues: [],
    isCalculateAll: false,
    language: localStorage.getItem('language') ? localStorage.getItem('language') : 'ja',
    localStorageLanguage: localStorage.getItem('language'),
    country: '',
    isProjectCopyReportAll: false,
    isProjectCopyFirst: false,
    isProjectCopyFirstForHeatmap: false,
    /** One-shot: after Results, first time adding menu 1–4 to a project that already has similarity (menu 6), allow 商品コピー + category edits. */
    surveyAllowEditableCopyAndCategoryOnce: false,
    /** Project ids for which the above one-shot was already consumed (confirm submitted). */
    surveyNormalMenuUnlockedAfterSimilarityProjectIds: [],
    /** One-shot: for an existing project, allow editing 商品コピー in Report All flow exactly once per project. */
    surveyAllowEditableReportAllCopyOnce: false,
    /** Project ids for which the above report-all one-shot was already consumed (confirm submitted). */
    surveyReportAllCopyUnlockedProjectIds: [],
    /** One-shot: after Results, first time adding similarity (menu 6) to a project that already has menu 1–4, allow selecting similarity categories even when projectId exists. */
    surveyAllowEditableSimilarityCategoryOnce: false,
    /** Project ids for which the above one-shot was already consumed (confirm submitted). */
    surveySimilarityUnlockedAfterNormalMenuProjectIds: [],
    limitNumberRequest: 0,
    targetCountry: constants.TARGET_COUNTRY_NONE,
    amountSetting: [],
    maxImageSetting: [],
    planAdhoc: null,
    dataAnalysis: {
      images: [],
      image_data: [],
      listPathImages: [],
      pathOriginImages: [],
      segment: [],
    },
    countAnalysis: 0,
    projectNameKeyVisual: '',
    projectIdKeyVisual: 0,
    typeSurvey: constants.TYPE_SURVEY_NORMAL,
    keyVisualToImg2img: null, // Payload for "Key Visual" → img2img: { dataUrl }
    autoGenerate30ToGenerateTab: null,
    similarityJobResultKnownReady: null,
    /** Selected task on similarity menu: plug_database | calculate_similarity */
    selectedSimilarityTask: constants.SIMILARITY_TASK_PLUG_DATABASE,
    /** True when GenerateConceptMessage shows the result panel (setting modal closed). */
    isGenerateConceptResultScreen: false,
    /** Bumped when GenerateConceptMessage ends project so cached menu page clears prior selection. */
    generateConceptMenuResetToken: 0,
  },
  getters: {
    isReachLimited(state, getters) {
      if (state.authUser && state.authUser.id) {
        // remove limit image for user free
        // if (state.authUser.plan && state.authUser.plan.max_images && state.authUser.used_amount >= state.authUser.plan.max_images) {
        //   return true;
        // }
        if (getters.isExpired) {
          return true;
        }
      }

      return false;
    },
    nImageUpload(state, getters) {
      return constants.MAX_IMAGES;
    },
    isMainPlanExpired(state) {
      if (!state.authUser || !state.authUser.expired_at) {
        return false;
      }
      const now = moment().unix();
      return state.authUser.expired_at - now <= 0;
    },
    isGeneratePlanExpired(state) {
      if (!state.authUser || !state.authUser.generate_expired_at) {
        return false;
      }
      const now = moment().unix();
      return state.authUser.generate_expired_at - now <= 0;
    },
    isExpired(state, getters) {
      if (!state.authUser) {
        return true;
      }
      // If user has both plans, both must be expired
      if (state.authUser.plan && state.authUser.plan_generate) {
        return getters.isMainPlanExpired && getters.isGeneratePlanExpired;
      }
      // If user has only one plan, check that one
      return getters.isMainPlanExpired || getters.isGeneratePlanExpired;
    },
    // Valuation plan (main plan) expired; ad-hoc users are excluded (post cron conversion).
    isValuationPlanExpired(state, getters) {
      if (!state.authUser || !state.authUser.plan) {
        return false;
      }
      if (getters.isUserAdhoc) {
        return false;
      }
      return getters.isMainPlanExpired;
    },
    canUseServiceChatGPT(state, getters) {
      if (!state.authUser) return false;
      if (state.authUser.country !== constants.COUNTRY_USER_JP) return false;
      if (getters.getCurrentLanguage !== constants.LANGUAGE_JA) return false;
      if (getters.region !== constants.REGION_JA) return false;
      return getters.isUserPlanGenerate;
    },
    canUseServiceValuationShelve(state, getters) {
      return state.authUser && state.authUser.plan && state.authUser.country === constants.COUNTRY_USER_JP && !getters.isUserNotFee && !getters.isValuationPlanExpired;
    },
    canUseServiceValuationSurvey(state, getters) {
      return state.authUser && state.authUser.plan && !getters.isValuationPlanExpired;
    },
    canUseServiceConceptValuation(state, getters) {
      if (!getters.canUseServiceValuationSurvey) return false;
      if (getters.region !== constants.REGION_JA) return false;
      if (getters.getCountryUser !== constants.COUNTRY_USER_JP) return false;
      if (getters.getCurrentLanguage !== constants.LANGUAGE_JA) return false;
      return getters.isUserPlanMonth;
    },
    canUseServiceAiGroupInterview(state, getters) {
      if (!getters.canUseServiceValuationSurvey) return false;
      if (getters.region !== constants.REGION_JA) return false;
      if (getters.getCountryUser !== constants.COUNTRY_USER_JP) return false;
      if (getters.getCurrentLanguage !== constants.LANGUAGE_JA) return false;
      return getters.isUserAdhoc || getters.isUserPlanMonth;
    },
    canUseServiceGenerateKeyVisual(state, getters) {
      if (!state.authUser) return false;
      if (state.authUser.country !== constants.COUNTRY_USER_JP) return false;
      if (getters.getCurrentLanguage !== constants.LANGUAGE_JA) return false;
      return getters.isUserPlanGenerate;
    },
    canUseServiceGenerateConcept(state, getters) {
      if (!state.authUser) return false;
      if (state.authUser.country !== constants.COUNTRY_USER_JP) return false;
      if (getters.getCurrentLanguage !== constants.LANGUAGE_JA) return false;
      return getters.isUserPlanGenerate;
    },
    isSuperAdmin(state) {
      if (state.authUser && state.authUser.id) {
        return state.authUser.is_superuser === constants.SUPERUSER;
      }

      return false;
    },
    isAdmin(state, getters) {
      if (state.authUser && state.authUser.id) {
        return !getters.isSuperAdmin && state.authUser.role === role.admin;
      }

      return false;
    },
    isUser(state, getters) {
      if (state.authUser && state.authUser.id) {
        return !getters.isSuperAdmin && !getters.isAdmin && state.authUser.role === role.user;
      }

      return false;
    },
    isUserAdhoc(state) {
      return state.authUser && state.authUser.plan && state.authUser.plan.plan_type === constants.PLAN_TYPE_ADHOC;
    },
    isUserFree(state) {
      return state.authUser && state.authUser.plan && state.authUser.plan.plan_type === constants.PLAN_TYPE_FREE;
    },
    isUserTrial(state) {
      return state.authUser && state.authUser.plan && state.authUser.plan.plan_type === constants.PLAN_TYPE_TRIAL;
    },
    isUserNotFee(state, getters) {
      return getters.isUserFree || getters.isUserTrial;
    },
    isUserPlanMonth(state) {
      return state.authUser && state.authUser.plan && state.authUser.plan.plan_type === constants.PLAN_TYPE_BY_MONTH;
    },
    isUserPlanGenerate(state) {
      if (!state.authUser || !state.authUser.plan_generate) return false;
      // Treat end_time = null (generate_expired_at = 0) as "no expiration" and active.
      if (!state.authUser.generate_expired_at) return true;
      return !isTimeExpired(state.authUser.generate_expired_at);
    },
    isUserAdminAdhoc(state, getters) {
      return getters.isUserAdhoc && getters.isAdmin;
    },
    isActiveUserPlanFreePhase5(state) {
      // from phase 5 and 1/6/2021 -> 1/7/2021: user plan free 10 images 2 weeks
      // from phase 1 -> 4: user plan free 10 images 2 months
      return state.authUser
        && state.authUser.plan
        && state.authUser.plan.plan_type === 3
        && state.authUser.plan.unit_type_period
        && state.authUser.plan.unit_type_period === 'weeks';
    },
    oldRegisteredProject(state) {
      return state.oldProjectRegisted;
    },
    oldProjectShelve(state) {
      return state.oldProjectShelve;
    },
    countImageUsed(state) {
      return state.authUser.used_amount || 0;
    },
    maxImagesOfPlan(state) {
      return state.authUser.plan.max_images || null;
    },
    maxImagesOfUser(state) {
      return state.authUser.max_images || 0;
    },
    getCurrentLanguage(state) {
      return state.language;
    },
    getLocalStorageLanguage(state) {
      return state.localStorageLanguage;
    },
    getAccessLanguage(state, getters) {
      return getters.getCurrentLanguage || 'ja';
    },
    getLanguageVer(state) {
      return state.country;
    },
    showStepInputText(state) {
      return state.targetCountry === constants.TARGET_COUNTRY_JP
        && (
          (!state.segmentHeatMap && !state.segmentConceptMatching)
          || state.isReportAll
        );
    },
    getAmountSetting(state) {
      return state.amountSetting;
    },
    getMaxImageSetting(state) {
      return state.maxImageSetting;
    },
    getCountryUser(state) {
      return state.authUser && state.authUser.country ? state.authUser.country : constants.COUNTRY_USER_JP;
    },
    showImageUse(state, getters) {
      return getters.isUserAdhoc || (getters.isUserPlanMonth && state.authUser && convertCountryToTargetCountry(state.authUser.country) !== state.targetCountry);
    },
    region() {
      return process.env.VUE_APP_REGION;
    },
    showByRegion() {
      return process.env.VUE_APP_REGION === constants.REGION_JA;
    },
    showByLanguage(state, getters) {
      return getters.getCurrentLanguage === constants.LANGUAGE_JA;
    },
    showNoticeHeatmap(state, getters) {
      return getters.region === constants.REGION_CN || (getters.region === constants.REGION_JA && getters.getCountryUser !== constants.COUNTRY_USER_JP);
    },
    canReportAnalysis(state, getters) {
      return getters.region === constants.REGION_JA &&
        getters.getCountryUser === constants.COUNTRY_USER_JP &&
        getters.getCurrentLanguage === constants.LANGUAGE_JA &&
        !getters.isUserNotFee;
    },
    showCostAnalysis(state, getters) {
      return state.countAnalysis > 0 && getters.isUserAdhoc;
    },
    typeSurvey(state) {
      return state.typeSurvey;
    },
    maxAccounts(state, getters) {
      let maxAccountWithPlan = constants.MAX_USERS_DEFAULT;

      if (state.authUser) {
        const plan = state.authUser.plan || null;
        const planGenerate = getters.isUserPlanGenerate ? state.authUser.plan_generate : null;

        if (planGenerate && plan) {
          maxAccountWithPlan = Math.min(planGenerate.max_accounts, plan.max_accounts);
        } else if (planGenerate) {
          maxAccountWithPlan = planGenerate.max_accounts;
        } else if (plan) {
          maxAccountWithPlan = plan.max_accounts;
        }
      }
      return maxAccountWithPlan;
    },
    showConceptMatching(state, getters) {
      // menu concept matching display with region ja, lang ja, country jp, plan adhoc or plan month
      return getters.region === constants.REGION_JA
        && getters.getCurrentLanguage === constants.LANGUAGE_JA
        && getters.getCountryUser === constants.COUNTRY_USER_JP
        && (getters.isUserPlanMonth || getters.isUserAdhoc);
    },
    // similarity_level menu active only for evaluation unlimited plan (by month); inactive for trial, free, ad-hoc
    isSimilarityLevelMenuActive(state, getters) {
      return getters.region === constants.REGION_JA
        && getters.getCurrentLanguage === constants.LANGUAGE_JA
        && getters.getCountryUser === constants.COUNTRY_USER_JP
        && getters.isUserPlanMonth;
    },
    isCalculateSimilarityTask(state) {
      const menuId = [
        state.currentMenu,
        state.menuChecked,
        state.paramsLastStep && state.paramsLastStep.projectTypeId,
        state.paramsLastRoute && state.paramsLastRoute.projectTypeId,
      ].find(v => v != null && v !== '' && Number(v) > 0);
      if (Number(menuId) !== constants.MENU_FOR_SIMILARITY_LEVEL) {
        return false;
      }
      if (state.selectedSimilarityTask === constants.SIMILARITY_TASK_CALCULATE_SIMILARITY) {
        return true;
      }
      const fromRoute = state.paramsLastRoute && state.paramsLastRoute.similarityTask;
      const fromStep = state.paramsLastStep && state.paramsLastStep.similarityTask;
      return fromRoute === constants.SIMILARITY_TASK_CALCULATE_SIMILARITY
        || fromStep === constants.SIMILARITY_TASK_CALCULATE_SIMILARITY;
    },
  },
  mutations: {
  	setAuthUser(state, {
      authUser,
      isAuthenticated
    }) {
      Vue.set(state, 'authUser', authUser);
      Vue.set(state, 'isAuthenticated', isAuthenticated)
    },
    updateToken(state, dataToken){
      localStorage.setItem('token', dataToken.token);
      localStorage.setItem('refresh', dataToken.refresh);
      state.jwt = dataToken.token;
    },
    removeToken(state){
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      state.jwt = null;
    },
    clearAuthInfo(state){
  	  Vue.set(state, 'authUser', {});
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      state.menuChecked = null;
      state.segmentChecked = [];
      state.paramsLastRoute = {}
      state.paramsLastStep = {}
      state.currentImageUpload = []
      state.currentImageUsed = 0
      state.projectId = 0
      state.projectName = '';
      state.projectNameAutoCreate = '';
      state.isSelectImageWord = false;
      state.nImage = 0;
      state.isAuthenticated = false;
      state.jwt = localStorage.getItem('token');
      state.lastRoute = null;
      state.pathCurrentImageUpload = [];
      state.isResultPage = false;
      state.selectedPlan = '';
      state.selectedPlanGenerate = '';
      state.currentMenu = 0;
      state.blur = constants.BLUR_LIST[0].id;
      state.categoryAutoCreate = 1;
      state.drinkFlag = null;
      state.imageShow = null;
      state.countComputation = 10;
      state.isReportAll = false;
      state.tabResultReportAll = false;
      state.isCalculateAll = false;
      state.projectReportAll = null;
      state.oldProjectRegisted = 0;
      state.isProjectCopyReportAll = false;
      state.isProjectCopyFirst = false;
      state.isProjectCopyFirstForHeatmap = false;
      state.surveyAllowEditableCopyAndCategoryOnce = false;
      state.surveyNormalMenuUnlockedAfterSimilarityProjectIds = [];
      state.surveyAllowEditableReportAllCopyOnce = false;
      state.surveyReportAllCopyUnlockedProjectIds = [];
      state.surveyAllowEditableSimilarityCategoryOnce = false;
      state.surveySimilarityUnlockedAfterNormalMenuProjectIds = [];
      state.selectedSimilarityTask = constants.SIMILARITY_TASK_PLUG_DATABASE;
      state.targetCountry = constants.TARGET_COUNTRY_JP;
      state.isGenerateConceptResultScreen = false;
      state.generateConceptMenuResetToken = 0;
    },
    setUserInfo(state, payload) {
      state.authUser[payload.field] = payload.data;
    },
    setIsAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    clearDataAllSteps(state) {
      state.currentImageUpload = []
      state.pathCurrentImageUpload = []
      state.pathCurrentOriginImageUpload = []
      state.currentImageUsed = 0
      state.menuChecked = null
      state.segmentChecked = []
      state.surveyAllowEditableCopyAndCategoryOnce = false
      state.surveyAllowEditableReportAllCopyOnce = false
      state.surveyAllowEditableSimilarityCategoryOnce = false
      state.selectedSimilarityTask = constants.SIMILARITY_TASK_PLUG_DATABASE
    },
    SET_LANGUAGE(state, lang) {
      localStorage.setItem('language', lang);
      state.language = lang;
      state.localStorageLanguage = lang;
    },
    SET_TARGET_COUNTRY(state, value) {
      if (value == null || value === '') {
        return;
      }
      const normalized = Number(value);
      if (Number.isNaN(normalized)) {
        return;
      }
      state.targetCountry = normalized;
    },
    SET_PLAN_ADHOC(state, plan) {
      state.planAdhoc = plan || null;
    },
    SET_TYPE_SURVEY(state, value) {
      state.typeSurvey = value;
    },
    SET_KEY_VISUAL_TO_IMG2IMG(state, payload) {
      state.keyVisualToImg2img = payload;
    },
    CLEAR_KEY_VISUAL_TO_IMG2IMG(state) {
      state.keyVisualToImg2img = null;
    },
    SET_AUTO_GENERATE_30_TO_GENERATE_TAB(state, payload) {
      state.autoGenerate30ToGenerateTab = payload;
    },
    CLEAR_AUTO_GENERATE_30_TO_GENERATE_TAB(state) {
      state.autoGenerate30ToGenerateTab = null;
    },
    SET_SELECTED_SIMILARITY_TASK(state, task) {
      state.selectedSimilarityTask = task;
      if (state.paramsLastStep) {
        Vue.set(state.paramsLastStep, 'similarityTask', task);
      }
    },
    SET_GENERATE_CONCEPT_RESULT_SCREEN(state, value) {
      state.isGenerateConceptResultScreen = !!value;
    },
    BUMP_GENERATE_CONCEPT_MENU_RESET_TOKEN(state) {
      state.generateConceptMenuResetToken += 1;
    },
    CLEAR_PROJECT_SESSION(state) {
      state.projectId = 0;
      state.paramsLastStep = {};
    },
  },
  actions:{
    obtainToken(username, password) {
      const payload = {
        username: username,
        password: password
      };
      axios.post(this.state.endpoints.obtainJWT, payload)
        .then((response)=>{
            this.commit('updateToken', response.data);
          })
        .catch((error)=>{
            console.log(error);
          })
    },
    async refreshToken({ commit }) {
      const payload = {
        refresh: localStorage.getItem('refresh'),
      };
      await axios.post(this.state.endpoints.refreshJWT, payload)
        .then(async (response)=>{
            await commit('updateToken', response.data)
          })
        .catch((error)=>{
          console.log(error)
        })
    },
	  async inspectToken({ dispatch }){
      const token = this.state.jwt;
      if(token){
        const decoded = jwt_decode(token);
        const exp = decoded.exp
        if (exp - (Date.now() / 1000) < 1800) {
          await dispatch('refreshToken');
        } else {
          // PROMPT USER TO RE-LOGIN, THIS ELSE CLAUSE COVERS THE CONDITION WHERE A TOKEN IS EXPIRED AS WELL
        }
      }
    },
    logout(state){
  	  this.commit('clearAuthInfo');
    },
    setLanguage({ commit }, payload) {
      const { lang, i18n } = payload;
      commit('SET_LANGUAGE', lang);
      i18n.locale = lang;
    },
  },
  modules: {
    plans,
    project,
    conceptValuation,
    generationHistory,
    aiGroupInterview,
  },
});
